import React from "react";
import { Link, useLocation } from "react-router-dom";

import { useUserContext } from "../context/User";
import { getTTIcon, getTTLogo, getUserIcon } from "../services/icons";
import NavLink from "./NavLink";

const menu = [
  { to: "/", title: "All dogs", active: true },
  // { to: "/shelters", title: "Dog shelters" },
  // { to: "/products", title: "Products" },
  { to: "/about", title: "About" },
];

export default function Head() {
  const { user, logout } = useUserContext();
  const loc = useLocation();

  return (
    <div className="bg-[#FFFFFF]">
      <header className="container mx-auto">
        <div className="flex flex-row items-center justify-between px-5 pb-8 pt-6">
          <Link to="/">
            <div className="flex flex-row items-center gap-1">
              {getTTIcon("#121111")}
              {getTTLogo()}
            </div>
          </Link>
          <div className="flex gap-14">
            <nav className="hidden flex-row gap-8 lg:flex">
              {menu.map((item, index) => {
                return <NavLink {...item} key={index} active={item.to === loc.pathname} />;
              })}
            </nav>
            {!user || (!user.accessToken && <Link to="/login">{getUserIcon()}</Link>)}
          </div>
        </div>
      </header>
    </div>
  );
}
